define(["jquery"], function ($) {
	function Init() {
	    var panelClose = $('.panel-collapse.collapse.container .btn.btn--close.close-panel');
		panelClose.on("click", function () {
		    this.closest('.panel-collapse.container').classList.remove('in');
		    this.closest('.panel-collapse.container').setAttribute('aria-expanded', 'false');
		});
	}

	return {
		Init: Init
	};
});